
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { CalendarMonth } from '@mui/icons-material';
import dayjs from 'dayjs';
import 'dayjs/locale/es';




export const DateFormScreen = ({ label, bloqueo=false, onChange, value, permitirPasado=false, ...props }) => {

    const normalizedValue = value ? dayjs(value) : null;

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
            <DatePicker
                label={label}
                disabled={bloqueo}
                value={normalizedValue}
                onChange={ onChange }
                format="DD/MM/YYYY"
                minDate={permitirPasado ? null : dayjs()}
                disablePast={!permitirPasado}
                slots={{ openPickerIcon: CalendarMonth }}
                slotProps={{
                    textField: {
                        fullWidth: true,
                        size: "small",
                        error: false,
                        sx: {'& .MuiOutlinedInput-root': {
                        '&:hover fieldset': {borderColor: 'primary.main'},
                    }}
                    },
                    openPickerIcon: { fontSize:'small' },
                    actionBar: { actions: ['clear', 'today', 'accept'] },
                    popper: { placement: 'auto' }
                }}
                {...props}
            />
        </LocalizationProvider>
    )
}

